import { Shimmer, ShimmerElementType } from '@fluentui/react';
import { useThemeData } from '@msrceng/theme';
import { times } from 'lodash';

/** This is a skeleton shimmer for details list that doesn't require actually loading the
 * ShimmeredDetailsList component, for use with suspense.
 */
export const LightDetailsListShimmer = ({ columns }) => {
  const { theme } = useThemeData();

  return (
    <div>
      <div
        style={{
          padding: '1em 0',
          borderBottom: '1px solid ' + theme?.palette?.neutralQuaternaryAlt,
        }}
      >
        <Shimmer shimmerElements={getShimmer(columns)} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: 25,
        }}
      >
        {times(10, i => (
          <Shimmer
            key={`shimmer-mock-row-${i}`}
            shimmerElements={getShimmer(columns)}
          />
        ))}
      </div>
      <div style={{ padding: 5 }}>
        <Shimmer width={'16em'} />
      </div>
    </div>
  );
};

const getShimmer = (columns: import('@fluentui/react').IColumn[]) => {
  const result: any[] = [{ type: ShimmerElementType.circle }, gap];
  columns.forEach?.(col => {
    result.push({
      type: ShimmerElementType.line,
      height: 26,
      width: Math.max(col.minWidth || 0, 20),
    });
    result.push(gap);
  });
  return result;
};
const gap = { type: ShimmerElementType.gap, width: 5, height: 20 };
